<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div class="col-form-label" :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"  v-if="fbhidelabel !== 'true'">
        
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b>{{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>
      <div class="col-form-input" :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'">
        <div v-if="!checkReadonly(isedit, fbreadonly)">
          <div class='js-signature'>
            <!-- JQUERY PLUGIN HANDLE -->
          </div>
          <p><button class="btn btn-default" @click="clearCanvas()">Clear</button></p>
        </div>
        <div v-if=" checkReadonly(isedit, fbreadonly)">
          <img :src="value" alt="Signature">
        </div>
        <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Signature',
  props: ['id', 'fbsupportmultiplelanguages','fblabel', 'fbplaceholder', 'value', 'fbvalue', 'fbmaxlength', 'format', 'fbreadonly', "fbinvisible", 'fblabelposition', 'labelwidth', 'fbrequired', 'fbhidelabel', 'fbhelptext', 'errormessage', 'allowedInput', 'type', 'blurValidation', 'isedit'],
  data () {
    return {

    }
  },
  mounted () {
    //https://bencentra.github.io/jq-signature/
    this.init();

  },
  methods: {
    init(){
      var vm = this;
      setTimeout(function(){
        var canvas = $(vm.$el).find('.js-signature'); //this canvas

        $(canvas).jqSignature({autoFit: true});

        if(vm.value){
          let image =  new Image();
          let ctx = $(canvas).children().first()[0].getContext("2d");

          image.onload = function() {
            ctx.drawImage(image, 0, 0);
          };
          image.src = vm.value;
        }


        $(canvas).on('jq.signature.changed', function(){
          var dataUrl = $(canvas).jqSignature('getDataURL');
          vm.value = dataUrl;
          vm.$emit('input', dataUrl, this);
        });
      }, 100)
      
    },
    checkReadonly(isedit, fbreadonly){
      let readonly = true;
      if(isedit){
        if(fbreadonly == 'true'){
          readonly = true;
        }else{
          readonly = false;
        }

      }else{
        readonly = true;
      }
      return readonly;
    },
    clearCanvas(){
      $($(this.$el).find('.js-signature')).jqSignature('clearCanvas');
    }
  },
  computed: {
   
  },
  watch: {
    isedit: function(){
      this.init();
    }
  }
}
</script>

<style scoped>
canvas{
  border: 1px solid #444;
  height: 150px;
  width: auto;
}
</style>
